import React from 'react';
import logo from '../../assets/footer/house.png';
import './styles.scss';

const Footer = (props) => {
  return (
    <div className="footer">
      <div className="left">
        <img className="footer_logo" src={logo} alt="navbarLogo" />
        <div className="company">© DartMate. All rights reserved.</div>
      </div>
      <div className="right">
        <div className="email">Email us at<strong className="dartmate_email"> dartmate.cs98@gmail.com </strong> for any inquiries.</div>

      </div>
    </div>
  );
};
export default Footer;
